{
  "appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Prendre un nouveau rendez-vous"
    },
    "meta": {
      "title": "Détails du rendez-vous",
      "description": "Toutes les informations concernant le rendez-vous"
    }
  }
}
